"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeImagePropertyHistoryItem = void 0;
var tslib_1 = require("tslib");
var interval_based_history_item_1 = require("../../base/interval-based-history-item");
var ChangeImagePropertyHistoryItem = (function (_super) {
    tslib_1.__extends(ChangeImagePropertyHistoryItem, _super);
    function ChangeImagePropertyHistoryItem(modelManipulator, subDocInterval, base64, size) {
        var _this = _super.call(this, modelManipulator, subDocInterval) || this;
        _this.base64 = base64;
        _this.size = size;
        return _this;
    }
    ChangeImagePropertyHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.floatingObject.image.setValue(this.boundSubDocument, this.interval, [this.base64, this.size]);
    };
    ChangeImagePropertyHistoryItem.prototype.undo = function () {
        this.modelManipulator.floatingObject.image.restoreValue(this.boundSubDocument, this.oldState);
    };
    return ChangeImagePropertyHistoryItem;
}(interval_based_history_item_1.IntervalBasedHistoryItem));
exports.ChangeImagePropertyHistoryItem = ChangeImagePropertyHistoryItem;
